import { KeyValue } from "@/main/models/common";

export enum ReportScheduleStatusTypes {
	GET_REPORT_SCHEDULE_STATUS = "@reportScheduleStatus/GET_REPORT_SCHEDULE_STATUS",
	SAVE_REPORT_SCHEDULE_STATUS = "@reportScheduleStatus/SAVE_REPORT_SCHEDULE_STATUS",
	RESET_REDUCER_REPORT_SCHEDULE_STATUS = "@reportScheduleStatus/RESET_REDUCER_REPORT_SCHEDULE_STATUS",
}

export interface ReportScheduleStatusState {
	readonly reportScheduleStatus: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetReportScheduleStatus {
	type: typeof ReportScheduleStatusTypes.GET_REPORT_SCHEDULE_STATUS;
}

export interface SaveReportScheduleStatus {
	type: typeof ReportScheduleStatusTypes.SAVE_REPORT_SCHEDULE_STATUS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerReportScheduleStatus {
	type: typeof ReportScheduleStatusTypes.RESET_REDUCER_REPORT_SCHEDULE_STATUS;
}

export type ReportScheduleStatusActionTypes =
	| GetReportScheduleStatus
	| SaveReportScheduleStatus
	| ResetReducerReportScheduleStatus;
